import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  deleteIndicator,
  deleteInterpretation,
  deleteRecommendation,
  deleteSignal,
  deleteSubject,
  getIndicators,
  getInterpretation,
  getRecommendations,
  getSignals,
  getSubjects,
  postIndicator,
  postInterpretation,
  postRecommendation,
  postSignal,
  postSubject,
  updateIndicator,
  updateInterpretation,
  updateRecommendation,
  updateSignal,
  updateSubject,
} from '../../api/smart-life';
import http, { remove } from '../../api/http';
import _ from 'underscore';
import { useAppDispatch } from '../../hooks/redux';

type InitialStateT = {
  subjects: { [id: string]: any };
  recommendations: { [id: string]: any };
  indicators: { [id: string]: any };
  signals: { [id: string]: any };
  interpretations: { [id: string]: any };
  isLoading: boolean;
};

const initialState: InitialStateT = {
  subjects: {},
  recommendations: {},
  indicators: {},
  signals: {},
  interpretations: {},
  isLoading: false,
};

export const getSubjectsThunk = createAsyncThunk(
  'data/getSubjects',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await getSubjects(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const patchSubjectsThunk = createAsyncThunk(
  'data/patchSubjects',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await updateSubject(item);
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const removeSubjectsThunk = createAsyncThunk(
  'data/removeSubjects',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await deleteSubject(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const postSubjectsThunk = createAsyncThunk(
  'data/postSubjects',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await postSubject(item);
      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getInterpretationThunk = createAsyncThunk(
  'data/getInterpretation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await getInterpretation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const patchInterpretationThunk = createAsyncThunk(
  'data/patchInterpretation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await updateInterpretation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const removeInterpretationThunk = createAsyncThunk(
  'data/removeInterpretation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await deleteInterpretation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const postInterpretationThunk = createAsyncThunk(
  'data/postInterpretation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await postInterpretation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getSignalThunk = createAsyncThunk(
  'data/getSignal',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await getSignals(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const patchSignalThunk = createAsyncThunk(
  'data/patchSignal',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await updateSignal(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const removeSignalThunk = createAsyncThunk(
  'data/removeSignal',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await deleteSignal(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const postSignalThunk = createAsyncThunk(
  'data/postSignal',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await postSignal(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getRecommendationThunk = createAsyncThunk(
  'data/getRecommendation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await getRecommendations(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const patchRecommendationThunk = createAsyncThunk(
  'data/patchRecommendation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await updateRecommendation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const removeRecommendationThunk = createAsyncThunk(
  'data/removeRecommendation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await deleteRecommendation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const postRecommendationThunk = createAsyncThunk(
  'data/postRecommendation',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await postRecommendation(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const getIndicatorThunk = createAsyncThunk(
  'data/getIndicator',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await getIndicators(item);
      return response?.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const patchIndicatorThunk = createAsyncThunk(
  'data/patchIndicator',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await updateIndicator(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const removeIndicatorThunk = createAsyncThunk(
  'data/removeIndicator',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await deleteIndicator(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);
export const postIndicatorThunk = createAsyncThunk(
  'data/postIndicator',
  async (item: any, thunkAPI) => {
    try {
      const response: any = await postIndicator(item);
      return response;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    clearData: (state) => {
      state = initialState;
    },
    patchSubject: (state, action) => {
      const item = action.payload || {};
      state.subjects[item._id] = item;
      return state;
    },
    patchRemove: (state, action) => {
      const { type, _id } = action.payload;
      if (type === 'subjects') {
        delete state.subjects[_id];
      } else if (type === 'indicators') {
        delete state.indicators[_id];
      } else if (type === 'interpretations') {
        delete state.interpretations[_id];
      } else if (type === 'recommendations') {
        delete state.recommendations[_id];
      }
      remove(`/api/core/theme/${type}/${_id}`, {}).then((r) => {
        const related = ((r || {}) as any).related || [];
        const g = global as any;
        g && g.fetchAll && g.fetchAll();
      });
      return state;
    },
    removeSubjects: (state, action) => {
      const item = action.payload;
      delete state.subjects[item._id];
      return state;
    },

    patchSignal: (state, action) => {
      const item = action.payload || {};
      state.signals[item._id] = item;
      return state;
    },
    removeSignal: (state, action) => {
      const item = action.payload;
      delete state.subjects[item._id];
      return state;
    },

    patchInterpretation: (state, action) => {
      console.log('qqqqq patch interpretation', action.payload);
      const item = action.payload || {};
      state.interpretations[item._id] = item;
      return state;
    },
    patchRecommendation: (state, action) => {
      console.log('qqqqq patch recommendation1!!!!!!!!!!!!', action.payload);
      const item = action.payload || {};
      state.recommendations[item._id] = item;
      return state;
    },
    removeInterpretation: (state, action) => {
      const item = action.payload;
      delete state.interpretations[item._id];
      return state;
    },
    patchIndicator: (state, action) => {
      const item = action.payload || {};
      console.log('patch indicatorrrrrrrr', state, state.indicators, item);
      state.indicators[item._id] = item;
      return state;
    },
    removeIndicator: (state, action) => {
      const item = action.payload;
      delete state.indicators[item._id];
      return state;
    },
    // set
    // post
    // update
    // remove
  },
  extraReducers: (builder) => {
    // get

    builder.addCase(getSubjectsThunk.fulfilled, (state, action) => {
      const data = action.payload?.data?.items || [];
      state.subjects = data.reduce((acc: any, item: any) => {
        const url = item._id;
        const name = item.name;
        const description = item.description || '';
        acc[item._id] = { ...item, url, description, name };
        return acc;
      }, {});
      return state;
    });

    builder.addCase(getInterpretationThunk.fulfilled, (state, action) => {
      const data = action.payload?.data?.items || [];
      state.interpretations = data.reduce((acc: any, item: any) => {
        acc[item._id] = item;
        return acc;
      }, {});
    });
    builder.addCase(getRecommendationThunk.fulfilled, (state, action) => {
      const data = action.payload?.data?.items || [];
      state.recommendations = data.reduce((acc: any, item: any) => {
        acc[item._id] = item;
        return acc;
      }, {});
    });
    builder.addCase(getSignalThunk.fulfilled, (state, action) => {
      const data = action.payload?.data?.items || [];
      state.signals = data.reduce((acc: any, item: any) => {
        acc[item._id] = item;
        return acc;
      }, {});
    });
    builder.addCase(getIndicatorThunk.fulfilled, (state, action) => {
      const data = action.payload?.items || [];
      state.indicators = data.reduce((acc: any, item: any) => {
        acc[item._id] = {
          ...item,
          unitType: item.unitType || { name: 'U/L' },
          scaleType: item.scaleType || { name: 'RAGGAR' },
        };
        return acc;
      }, {});
    });

    // post
    builder.addCase(postSubjectsThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(postSubjectsThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(postSubjectsThunk.fulfilled, (state, action) => {
      const res: any = action.payload;
      state.subjects[res._id] = res;
      state.isLoading = false;
    });
    builder.addCase(postInterpretationThunk.fulfilled, (state, action) => {
      const res: any = action.payload;
      state.indicators[res._id] = res;
    });
    builder.addCase(postSignalThunk.fulfilled, (state, action) => {
      const res: any = action.payload?.data;
      if (res && res._id) {
        state.signals[res._id] = res;
      }
    });
    builder.addCase(postRecommendationThunk.fulfilled, (state, action) => {
      const res: any = action.payload;
      state.indicators[res._id] = res;
    });
    builder.addCase(postIndicatorThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(postIndicatorThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(postIndicatorThunk.fulfilled, (state, action) => {
      const res: any = action.payload;
      state.indicators[res._id] = res;
      state.isLoading = false;
    });
  },
});

export const {
  patchSubject,
  patchSignal,
  patchInterpretation,
  patchRecommendation,
  patchIndicator,
  patchRemove,
} = dataSlice.actions;

export default dataSlice.reducer;
